<template>
  <div>
    <a-modal
      :title="title"
      :visible="failModalStatus"
      :confirm-loading="confirmLoading"
      @cancel="closeModal"
      width="1344px"
    >
      <failNoticeTable
        :tableList="tableList"
        :total="total"
        :setPageNum="setPageNum"
        ref="failNoticeTable"
      />
      <template slot="footer">
        <div>
          <a-button @click="closeModal">关闭</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import failNoticeTable from './failNoticeTable'
import api from '../../commomFun/api.js'
export default {
  props: {
    failModalStatus: Boolean,
    datalist: Array
  },
  data () {
    return {
      confirmLoading: false,
      tableList: [],
      pageNum: 1,
      total: 5,
      title: '下发通知失败',
      type: 1
    };
  },
  components: {
    failNoticeTable
  },
  methods: {
    getSendAdMachineInfoByPlanId (type) {
      if(type) {
        this.type = type
      }
      if (this.type === -2) {
        this.title = '下载失败'
      } else {
        this.title = '下发通知失败'
      }
      api.getApi('/adPlan/getSendAdMachineInfoByPlanId', {
        planId: sessionStorage.getItem('planId') || '',
        status: this.type,
        pageNum: this.pageNum,
        pageSize: 5,
      }).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.tableList = data.list.map((item, idx) => {
            item.key = idx
            return item
          })
          this.total = data.total
        }
      })
    },
    setPageNum(current){
      this.pageNum = current
      this.getSendAdMachineInfoByPlanId()
    },
    handleOk (e) {
      this.confirmLoading = true;
      setTimeout(() => {
        this.confirmLoading = false;
      }, 2000);
    },
    closeModal () {
      this.$parent.failModalStatus = false
    },
  },
};
</script>
